import { ContentBlockSchemaRoot } from '@/models/content-block-schema.model';
import { IContentBlockInstance } from '@/models/content-page.model';
import { SupportedLocales } from '@/models/localization.model';
import { buildDefaultBlockData } from './schemaDefaults';

export const generateBlockId = (): string =>
  typeof crypto !== 'undefined' && crypto.randomUUID
    ? crypto.randomUUID()
    : `blk-${Date.now()}-${Math.random().toString(36).slice(2, 9)}`;

export const createEmptyBlock = (
  blockType: string,
  schema: ContentBlockSchemaRoot,
  locales: SupportedLocales[],
): IContentBlockInstance => ({
  id: generateBlockId(),
  type: blockType,
  data: buildDefaultBlockData(schema, locales),
});
